import { render, staticRenderFns } from "./town.vue?vue&type=template&id=14caa25c&scoped=true&"
import script from "./town.vue?vue&type=script&lang=js&"
export * from "./town.vue?vue&type=script&lang=js&"
import style0 from "./town.vue?vue&type=style&index=0&id=14caa25c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14caa25c",
  null
  
)

export default component.exports